// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'

import fr from 'vee-validate/dist/locale/fr'
import VeeValidate, {Validator} from 'vee-validate'

import VueTheMask from 'vue-the-mask'
import VueMoney from 'v-money'
import VueSwal from 'vue-swal'

import lodash from 'lodash'
import VueLodash from 'vue-lodash'

import {createI18n} from './i18n'
import {ToggleButton} from 'vue-js-toggle-button'
import 'abp-web-resources'

import BootstrapVue from 'bootstrap-vue'
window.moment = require('moment')

//Bootstrap theme CSS
import 'startbootstrap-sb-admin/css/sb-admin.min.css'
import 'startbootstrap-sb-admin/vendor/bootstrap/css/bootstrap.min.css'
import 'startbootstrap-sb-admin/vendor/font-awesome/css/font-awesome.min.css'
import 'startbootstrap-sb-admin/vendor/datatables/dataTables.bootstrap4.css'

import 'pace-js/themes/blue/pace-theme-flat-top.css'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'select2/dist/css/select2.min.css'

// //Bootstrap theme Scripts
import 'bootstrap'
import 'startbootstrap-sb-admin/vendor/jquery-easing/jquery.easing.min.js'
import 'startbootstrap-sb-admin/vendor/chart.js/Chart.min.js'

window.JSZip = require('jszip') //import 'jszip' dont work -- its used for the datatable Excel exporter

import 'startbootstrap-sb-admin/vendor/datatables/jquery.dataTables.js'
//import 'startbootstrap-sb-admin/vendor/datatables/dataTables.bootstrap4.js'

//import 'startbootstrap-sb-admin/js/sb-admin.min.js'
import 'startbootstrap-sb-admin/js/sb-admin-datatables.min.js'

import 'datatables.net-buttons'
import 'datatables.net-buttons-bs'

import 'datatables.net-buttons/js/buttons.colVis'
import 'datatables.net-buttons/js/buttons.html5'
import 'datatables.net-buttons/js/buttons.flash'
import 'datatables.net-buttons/js/buttons.print'

import 'datatable-sorting-datetime-moment'

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

import 'select2'
import 'select2/dist/js/i18n/fr'

pdfMake.vfs = pdfFonts.pdfMake.vfs

import 'startbootstrap-sb-admin/vendor/datatables/dataTables.bootstrap4.js'

import 'pace-js/pace.min.js'
Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(VueLodash, lodash)

Vue.use(VueSwal)

Vue.use(VueCookie)

Vue.use(CKEditor)

Vue.use(ToggleButton)

Vue.use(VeeValidate, {
  locale: 'fr',
  dictionary: {
    fr: {messages: fr},
  },
})

Validator.localize('fr', fr)

Vue.use(BootstrapVue)

Validator.extend('password', {
  getMessage: field => 'passwordPolicy',
  validate: function(value) {
    var hasMajRegex = new RegExp('(?=.*[A-Z])')
    var hasMaj = hasMajRegex.test(value)
    var hasSpecialRegex = new RegExp('(?=.*[|!"/$%?&*() ±@£¢¤¬¦²³¼^¸;`,.é^¨:`\'É~{}¯­´àôîè])')
    var hasSpecial = hasSpecialRegex.test(value)
    var hasNumberRegex = new RegExp('.*[0-9].*')
    var hasNumber = hasNumberRegex.test(value)

    var validLenght = value.length >= 8 && value.length <= 32

    return hasMaj && hasSpecial && hasNumber && validLenght
  },
})

Vue.use(VueTheMask)
Vue.use(VueMoney, {
  precision: 0,
  decimal: ',',
  thousands: '',
  prefix: '',
  masked: false,
})

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDatetime', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
})

$.extend(true, $.fn.dataTable.defaults, {
  paging: false,
  oLanguage: {
    sUrl: '//cdn.datatables.net/plug-ins/1.10.16/i18n/French.json',
  },
})

const i18n = createI18n()

/* eslint-disable no-new */
let vue = new Vue({
  store,
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: {App},
})



// WEBPACK FOOTER //
// ./src/main.js